export default __webpack_public_path__ + "static/media/american-express.f1e74639.svg";